import { ReactNode, memo } from 'react';
import { Link as RouterLink } from 'react-router';
import { Box, useTheme, Link, IconButton } from '@mui/material';
import { ArrowBack, Refresh } from '@mui/icons-material';

interface PageHeaderProps {
    backLink?: { label: string; href: string };
    children?: ReactNode;
    onRefresh?: () => void;
}

const PageHeader = ({ backLink, children, onRefresh }: PageHeaderProps) => {
    const theme = useTheme();

    const handleRefresh = () => {
        if (onRefresh) {
            onRefresh();
        }
    };

    return (
        <Box
            px={2}
            py={!children && backLink ? 0.75 : 1.5}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 0.5,
                backgroundColor: theme.palette.background.paper,
                borderTop: `1px solid ${theme.palette.divider}`,
                borderBottom: `1px solid ${theme.palette.divider}`,
                width: '100%',
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                    {backLink && (
                        <Link
                            component={RouterLink}
                            to={backLink.href}
                            underline="hover"
                            fontSize={13}
                            color="gray.60"
                            sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}
                        >
                            <ArrowBack sx={{ fontSize: 13, color: theme.palette.gray[60] }} />
                            {backLink.label}
                        </Link>
                    )}
                </Box>
                {onRefresh && (
                    <IconButton onClick={handleRefresh} size="small" sx={{ color: theme.palette.gray[60] }} aria-label="refresh page">
                        <Refresh fontSize="small" />
                    </IconButton>
                )}
            </Box>
            {children}
        </Box>
    );
};

export default memo(PageHeader);
